"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.functions = void 0;
const auth_1 = require("./auth");
const artists_1 = require("./artists");
const payments_1 = require("./payments");
const sms_1 = require("./sms");
const shoutouts_1 = require("./shoutouts");
const meetgreet_1 = require("./meetgreet");
function functions(app) {
    return {
        auth: (0, auth_1.init)(app),
        artists: (0, artists_1.init)(app),
        payments: (0, payments_1.init)(app),
        sms: (0, sms_1.init)(app),
        shoutouts: (0, shoutouts_1.init)(app),
        meetgreet: (0, meetgreet_1.init)(app),
    };
}
exports.functions = functions;
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (functions) {
    functions.auth = auth_1.auth;
    functions.artists = artists_1.artists;
    functions.payments = payments_1.payments;
    functions.sms = sms_1.sms;
    functions.shoutouts = shoutouts_1.shoutouts;
    functions.meetgreet = meetgreet_1.meetgreet;
})(functions = exports.functions || (exports.functions = {}));
//# sourceMappingURL=index.js.map